var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c(
      "form",
      {
        staticClass: "sign-up is-centered",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.onSubmit($event)
          }
        }
      },
      [
        _c("img", { attrs: { src: _vm.logo, alt: "logo" } }),
        _c("h1", { staticClass: "title is-4 has-text-primary" }, [
          _vm._v("\n      Registro\n    ")
        ]),
        _c("SignUpWithRfcFields", {
          attrs: {
            loading: _vm.loading,
            disabled: _vm.loading,
            "refer-code": ""
          }
        }),
        _c("ButtonSubmit", {
          attrs: { loading: _vm.loading, text: "regístrate" }
        }),
        _c("LinkSignIn"),
        _c("LinkForgottenPassword")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }